import "fit-text-webcomponent";
import "../../../src/docReady.js";
import Dom from "../../../src/Dom.js";
import isMobile from "../../../src/isMobile.js";
import Helper from "../../../src/Helper.js"; // easing
import "./style.scss";

const moduleSelector = ".eiovisual-collapse1";

/**
 * Classe esempio
 */
class Module {
  // _________________________________________________________________________

  constructor() {
    this.run();

    Helper.debug("Modulo collapse1");
  }

  // _________________________________________________________________________

  /**
   * Run di questo block.
   * @returns this
   */
  run() {
    var that = this;

    docReady(() => {
      let $modules = document.querySelectorAll(moduleSelector);

      // avvia il carousel per ogni modulo trovato
      $modules.forEach($module => {
        new ModuleFeature($module);
      });
    });
  }
}

class ModuleFeature {
  constructor($module) {
    this.$module = $module;

    this.init_feature();
  }

  // _________________________________________________________________________

  init_feature() {
    // Tasks on images
    setTimeout(() => { this.task1(); },0); // prima l'immagine centrale
  }

  /**
   * Accordion di gruppo
   * @returns {undefined}
   */
  task1() {

  }
}

// export
export default new Module();
